module.exports = __webpack_public_path__ + "static/img/sy_2.fc2a7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_2.png
// module id = JYXP
// module chunks = 1